module.exports = __webpack_public_path__ + "img/org_2.0032ebdf.jpeg";